RivalIQ.module('apps', function (apps, App, Backbone, Marionette, $, _) {

    'use strict';

    const app = apps.SocialChannelMatrix = window.createMarionetteApp();
    app.name = 'SocialChannelMatrix';

    app.addRegions({
        toolbar: '#toolbar-region',
        socialChannelMatrix: '.x-social-channel-matrix',
        modal: '.x-social-channel-matrix-modal-region'
    });

    app.on('start', function () {

        Backbone.history.start({
            root: '/channelMatrix'
        });
    });

});
